export const SUPER_ADMIN_EMAIL = "sadmin@yopmail.com";

export const getStoredAdminUser = () => {
  const storedAdmin = localStorage.getItem("admin_user");
  if (!storedAdmin) return null;

  try {
    return JSON.parse(storedAdmin);
  } catch (_) {
    return null;
  }
};

export const isSuperAdmin = () => {
  const adminUser = getStoredAdminUser();
  return adminUser?.email?.toLowerCase() === SUPER_ADMIN_EMAIL;
};

export const normalizePermissions = (permissions) => {
  if (!permissions) return [];
  if (Array.isArray(permissions)) {
    return permissions
      .map((permission) =>
        typeof permission === "string"
          ? permission
          : permission?.key ?? permission?.permission ?? permission?.permission_key ?? permission?.name ?? permission?.value
      )
      .filter(Boolean)
      .map(String);
  }
  if (typeof permissions === "string") {
    try {
      const parsed = JSON.parse(permissions);
      return normalizePermissions(parsed);
    } catch (_) {
      return permissions.split(",").map((item) => item.trim()).filter(Boolean);
    }
  }
  if (typeof permissions === "object") {
    return Object.entries(permissions)
      .flatMap(([key, value]) => {
        if (value === true || value === 1 || value === "1" || value === "true") return [key];
        if (value === false || value === 0 || value === "0" || value === "false" || value == null) return [];
        return normalizePermissions(value);
      })
      .filter(Boolean)
      .map(String);
  }
  return [];
};

export const getStoredAdminPermissions = () => {
  const adminUser = getStoredAdminUser();
  return normalizePermissions(
    adminUser?.permissions ??
      adminUser?.perms ??
      adminUser?.role_permissions ??
      adminUser?.role?.permissions ??
      adminUser?.role?.perms
  );
};

export const hasPermission = (permission) => {
  if (isSuperAdmin()) return true;
  const permissions = getStoredAdminPermissions();
  const aliases = {
    createUser: ["createUser", "addUser"],
    addUser: ["addUser", "createUser"],
  };
  return (aliases[permission] || [permission]).some((key) => permissions.includes(key));
};
